/** A failed module import stays cached until a new document loads. */
export async function reloadSavedPhase({ capture, hasWork, save, reload }) {
  const snapshot = capture();
  if (!hasWork(snapshot)) {
    reload();
    return;
  }
  if (!snapshot.accountId) {
    throw new Error('Sign in to save your current draft before reloading. Your work is still in this tab.');
  }
  const signature = JSON.stringify(snapshot);
  if (await save() !== true) {
    throw new Error('Your current work could not be saved. Keep this tab open and try saving again before reloading.');
  }
  if (JSON.stringify(capture()) !== signature) {
    throw new Error('Your account or work changed while saving. Save and reload again to keep the latest changes.');
  }
  reload();
}
